import React, { useMemo, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CardHeader, Table } from "reactstrap";
import Select from "react-select";
import { Button, FormGroup, Label, Row, Col, Input, CardBody, Container, Card } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import TableContainer from "components/Common/TableContainer";
import Breadcrumbs from "components/Common/Breadcrumb";
import { convertPayment, deleteManualPunch, fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchExtraDutyPaymentClaimList, fetchManualPunchList, resetAll, saveManualPunch } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "components/Common/custom-select";
import CustomMonthPicker from "common/CustomMonthPicker";
import { FaCheck } from "react-icons/fa";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import CustomDatePicker from "common/CustomDatePicker";
import CustomTimePicker from "common/CustomTimePicker";
import dayjs from "dayjs";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const ManualPunch = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
    const [authDetails, setAuthDetails] = useState(null);
    const dispatch = useDispatch()

    // const { categories } = useSelector((state) => state.CategoryMaster || {});
    // const { departments } = useSelector((state) => state.DepartmentMaster || {});
    // const { designations } = useSelector((state) => state.DesignationMaster || {});

    const {
        manualPunchList,
        dropdownAutoList,
        loading,
        success,
        error,
    } = useSelector((state) => ({
        dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
        manualPunchList: state.AttendanceExtraDutyReducer?.manualPunchList ?? [],

        loading: state.AttendanceExtraDutyReducer?.loading,
        error: state.AttendanceExtraDutyReducer?.error,
        success: state.AttendanceExtraDutyReducer?.success,
    }));
    const [shiftDetails, setShiftDetails] = useState([]);
    const [deleteMode, setDeleteMode] = useState(false);
    const [timesheetApprovalData, setTimesheetApprovalData] = useState([]);
    const [showShiftDetails, setShowShiftDetails] = useState(false);

    useEffect(() => {
        if (manualPunchList) {
            // ✅ Punch list
            if (manualPunchList.punch_details?.length > 0) {
                const initializedData = manualPunchList.punch_details.map((row) => ({
                    ...row,
                    selectedOption: "Discussion",
                }));
                setTimesheetApprovalData(initializedData);
            } else {
                setTimesheetApprovalData([]);
            }

            if (manualPunchList?.shift_detail?.length > 0) {
                const shiftInfo = manualPunchList.shift_detail[0];
                const shiftDisplay = `${shiftInfo.shift_code || ""} : ${shiftInfo.in_time || ""} - ${shiftInfo.out_time || ""}`;
                formikAddPunch.setValues({
                    ...formikAddPunch.values,
                    shift: shiftInfo.shift_code || "",
                    shiftDisplay: shiftDisplay || "",
                    punchDate: shiftInfo.shift_date || "",
                    punchTime: "",
                    remarks: "",
                });

                setShowShiftDetails(true);
            } else {
                formikAddPunch.resetForm();
                setShowShiftDetails(false);
            }
        }
    }, [manualPunchList]);

    useEffect(() => {
        dispatch(resetAll());
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchEmployeeDropdownAutoList(unitId));
    }, [dispatch]);

    // Formik Setup
    const formik = useFormik({
        initialValues: {
            employee: null,
            fromDate: "",
        },
        validationSchema: Yup.object({
            employee: Yup.object()
                .nullable()
                .required("Employee is required"),
            fromDate: Yup.string().nullable()
                .required("Punch Date is required"),
        }),
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append("emp_id", values.employee?.value || "");
            formData.append("punch_date", values.fromDate || "");
            formData.append("unit_id", authDetails?.unit_id || "");
            dispatch(fetchManualPunchList(formData))
        },
    });

    
    useEffect(() => {
        if (!formik.values.employee || !formik.values.fromDate) {
            setShowShiftDetails(false);
            return;
        }

        // If you want it to auto-hide whenever user changes either field
        setShowShiftDetails(false);

    }, [formik.values.employee, formik.values.fromDate]);

    useEffect(() => {
        if (success) {
            // handleCancel();
            const formData = new FormData();
            formData.append("emp_id", formik.values.employee?.value || "");
            formData.append("punch_date", formik.values.fromDate || "");
            formData.append("unit_id", authDetails?.unit_id || "");
            dispatch(fetchManualPunchList(formData))
        }
    }, [authDetails,success,dispatch]);

    const formikAddPunch = useFormik({
        initialValues: {
            shift: "",
            shiftDisplay: "",
            punchDate: "",
            punchTime: "",
            remarks: "",
        },
        validationSchema: Yup.object({
            punchDate: Yup.string().nullable().required("Date is required"),
            // punchTime: Yup.string().nullable().required("Time is required"),
            punchTime: Yup.string().nullable().when([], {
                is: () => !isAnyApproved, // required only if not deleting
                then: Yup.string().required("Time is required"),
                otherwise: Yup.string().nullable(),
            }),
            remarks: Yup.string()
                .nullable()
                .max(100, "Remarks cannot exceed 100 characters")
                .required("Remarks is required"),
        }),
        onSubmit: (values, { resetForm }) => {
            const formatTo24 = (timeObj) => {
                if (!timeObj) return "";
                if (dayjs.isDayjs(timeObj)) return timeObj.format("HH:mm:ss");
                const parsed = dayjs(timeObj, ["h:mm A", "hh:mm A"]);
                return parsed.isValid() ? parsed.format("HH:mm:ss") : "";
            };
            const formData = new FormData();

            // ✅ Common fields for both Add and Delete
            formData.append("emp_id", formik.values.employee?.value || 0);
            // formData.append("shift", values.shift || "");
            formData.append("punch_date", formik.values.fromDate || "");
            if (values.punchTime) formData.append("punch_time", formatTo24(values.punchTime));
            formData.append("remarks", values.remarks || "");
            formData.append("unit_id", authDetails?.unit_id || "");
            formData.append("create_by", authDetails?.user_id || "");

            if (deleteMode) {
                // ✅ Additional field for Delete
                const itemsPayload = {
                    manualPunchDtls: timesheetApprovalData
                        .filter((row) => row.selectedOption === "Delete")
                        .map((row) => ({ post_id: row.post_id })),
                };
                formData.append("items", JSON.stringify(itemsPayload));

                dispatch(deleteManualPunch(formData));
            } else {
                dispatch(saveManualPunch(formData));
            }
            //   console.log("FormData:", Object.fromEntries(formData));

        },
    });

    const isAnyApproved = useMemo(() => {
        return (timesheetApprovalData || []).some(
            (row) => row.selectedOption === "Delete"
        );
    }, [timesheetApprovalData]);

    const handleBulkActionChange = (action, checked) => {
        const updatedData = (timesheetApprovalData || []).map((row) => ({
            ...row,
            selectedOption: checked ? action : "", // clear if unchecked
        }));
        setTimesheetApprovalData(updatedData);
    };

    const handleOptionChange = (rowId, action, checked) => {
        const updatedData = timesheetApprovalData.map((row) => {
            if (row.post_id === rowId) {
            return { ...row, selectedOption: checked ? action : "" }; // toggle
            }
            return row;
        });
        setTimesheetApprovalData(updatedData);
    };


    const columns = [
            { Header: "S.No", Cell: ({ row }) => timesheetApprovalData.length - row.index, className: "serial-no", applyHeaderClass: true, },
            { Header: "Punch Time", accessor: "break_timings" },
            { Header: "Punch Order", accessor: "punch_order" },
            { Header: "Punch Type", accessor: "punch_type" },
            {
                id: "delete",
                Header: () => {
                    const allSelected = (timesheetApprovalData || []).every(
                    (row) => row.selectedOption === "Delete"
                    );

                    return (
                    <div className="text-center">
                        <Input
                        type="checkbox"
                        checked={allSelected}
                        onChange={(e) => handleBulkActionChange("Delete", e.target.checked)}
                        />
                    </div>
                    );
                },
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-center align-items-center">
                    <Input
                        type="checkbox"
                        checked={row.original.selectedOption === "Delete"}
                        onChange={(e) =>
                        handleOptionChange(row.original.post_id, "Delete", e.target.checked)
                        }
                    />
                    </div>
                ),
            }
    ];


    const handleCancel = () => {
        setTimesheetApprovalData([])
        formik.resetForm();
        setDeleteMode(false); 
    }

    return (

        <React.Fragment>
            <div className="page-content">
                <Loader loading={loading} />
                <Container fluid>
                    <Breadcrumbs title="Biometric" breadcrumbItem="Manual Punch" />

                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <form onSubmit={formik.handleSubmit}>
                                        <Row >
                                           

                                            <Col md={3}>
                                                <FormGroup>
                                                <Label for="employee">Employee <span className="text-danger">*</span></Label>
                                                <CustomSelect
                                                    id="employee"
                                                    name="employee"
                                                    options={(dropdownAutoList || []).map(emp => ({ value: emp.emp_id.toString(), label: emp.emp_no }))}
                                                    value={formik.values.employee || null}
                                                    // onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                                                    onChange={(selectedOption) => {
                                                        formik.setFieldValue("employee", selectedOption);
                                                        setShowShiftDetails(false);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    className={formik.touched.employee && formik.errors.employee ? "is-invalid" : ""}
                                                />
                                                {formik.touched.employee && formik.errors.employee && (
                                                    <div className="text-danger">{formik.errors.employee}</div>
                                                )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3} className="mb-3">
                                                <FormGroup>
                                                <Label for="fromDate">Punch Date <span className="text-danger">*</span></Label>
                                                <CustomDatePicker
                                                    name="fromDate"
                                                    value={formik.values.fromDate}
                                                    // onChange={(date) => formik.setFieldValue("fromDate", date)}
                                                    onChange={(date) => {
                                                        formik.setFieldValue("fromDate", date);
                                                        setShowShiftDetails(false);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    disableFuture={true}
                                                    className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                                                />
                                                {formik.touched.fromDate && formik.errors.fromDate && (
                                                    <div className="text-danger">{formik.errors.fromDate}</div>
                                                )}
                                                </FormGroup>
                                            </Col>

                                            {/* Buttons */}
                                            <Col className="d-flex align-items-center justify-content-end mob-center">
                                                <Button type="submit" className="btn button-search me-2">
                                                    <i className="fas fa-search me-1" /> Search
                                                </Button>
                                                <Button type="reset" color="secondary" onClick={handleCancel} className="btn button-cancel me-2"> <i className="fas fa-sync me-1" /> Cancel
                                                </Button>
                                            </Col>
                                        </Row>
                                    </form>
                                </CardBody>
                            </Card>
                        {((canCreate || canEdit ) && showShiftDetails) ? (
                            <Card>
                                <CardHeader className="bg-light border-bottom py-3">
                                    <form onSubmit={formikAddPunch.handleSubmit}>
                                    <Row className="align-items-center">
                                        {/* Shift (Label) */}
                                        <Col md={2}>
                                        <Label className="fw-bold mb-0">Shift:</Label>
                                        <div><span className="text-danger">{formikAddPunch.values.shiftDisplay}</span></div>
                                        </Col>

                                        {/* Date Input */}
                                        <Col md={2}>
                                        <Label className="fw-bold mb-1">Date:</Label>
                                        <div><span className="text-danger">{formikAddPunch.values.punchDate}</span></div>
                                        </Col>
                                        {!isAnyApproved && (
                                            <Col md={2}>
                                                <Label className="fw-bold mb-1">Time <span className="text-danger">*</span></Label>
                                                <CustomTimePicker
                                                    name="punchTime"
                                                    value={formikAddPunch.values.punchTime}
                                                    onChange={(val) => formikAddPunch.setFieldValue("punchTime", val)}
                                                    onBlur={() => formikAddPunch.setFieldTouched("punchTime", true)}
                                                    placeholder="Select Time"
                                                    format="hh:mm A"
                                                    />
                                                    {formikAddPunch.touched.punchTime && formikAddPunch.errors.punchTime && (
                                                    <div className="text-danger small">{formikAddPunch.errors.punchTime}</div>
                                                    )}
                                            </Col>
                                        )}
                                        

                                        {/* Remarks */}
                                        <Col md={isAnyApproved ? 6 : 4}>
                                        <Label className="fw-bold mb-1">Remarks <span className="text-danger">*</span></Label>
                                        <Input
                                            type="text"
                                            name="remarks"
                                            placeholder="Enter remarks"
                                            value={formikAddPunch.values.remarks}
                                            onChange={formikAddPunch.handleChange}
                                            onBlur={formikAddPunch.handleBlur}
                                            invalid={
                                            formikAddPunch.touched.remarks &&
                                            !!formikAddPunch.errors.remarks
                                            }
                                        />
                                        {formikAddPunch.touched.remarks &&
                                            formikAddPunch.errors.remarks && (
                                            <div className="text-danger small">
                                                {formikAddPunch.errors.remarks}
                                            </div>
                                            )}
                                        </Col>

                                        {/* Save Button */}
                                        <Col className="d-flex align-items-center justify-content-end mob-center">
                                            {!isAnyApproved && canCreate && (
                                                <Button
                                                type="submit"
                                                className="btn button-save me-2"
                                                onClick={() => setDeleteMode(false)}
                                                >
                                                <i className="fas fa-save me-1" /> Add Punch
                                                </Button>
                                            )}

                                            {isAnyApproved && canDelete && (
                                                <Button
                                                type="submit"
                                                className="btn button-delete me-2"
                                                onClick={() => setDeleteMode(true)}
                                                >
                                                <i className="fas fa-trash me-1" /> Delete
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                    </form>
                                </CardHeader>
                                <CardBody>
                                    <TableContainer
                                        columns={columns}
                                        data={timesheetApprovalData && timesheetApprovalData.length > 0 ? timesheetApprovalData : []}
                                        isGlobalFilter={true}
                                        customPageSize={10}
                                        className="custom-header-css"
                                    />
                                </CardBody>
                            </Card>
                        ) : (
                        // <Card>
                        //     <CardBody className="text-center py-4">
                        //     <h6 className="text-muted mb-0">Shift details will appear here once assigned.</h6>
                        //     </CardBody>
                        // </Card>
                                <Card>
                                    <CardBody className="text-center py-4">
                                        <i className="fas fa-info-circle fa-2x mb-2" />
                                        <p className="mb-0">No Records Found</p>
                                    </CardBody>
                                </Card>
                            )}                       

                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>


    );
};

export default ManualPunch;
